
  import {Component, Vue} from 'vue-property-decorator';
  import {ICarList} from '@/modules/CarList/interfaces/car-list.interface';
  import {mapGetters} from "vuex";
  import {ICar} from "@/modules/Car/interfaces/car.interface";
  import CarListEmpty from "@/modules/CarList/components/CarListEmpty.vue";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";

  @Component({
    components: {
      CarListEmpty,
    },
    computed: mapGetters({
      carList: "carList/sortedList",
    })
  })
  export default class CarListTable extends Vue {
    publicPath: string = process.env.VUE_APP_PUBLIC_URL;
    statuses = ICar.CarStatusId;
    carList: ICar.IEntity[];
    sortedType: ICarList.SortedType = ICarList.SortedType.OwnerByAlphabet;
    sortDirectionUp = true;
    carStatusesMap = {};
    sortedTypes = ICarList.SortedType;

    get tableCells() {
      return [
        { label: 'Номер',       prop: 'carNumber', sortedType: this.sortedTypes.CarNumber },
        { label: 'Статус',      prop: 'carStatusId', sortedType: this.sortedTypes.CarStatusId },
        { label: 'ФИО',         prop: 'persName', sortedType: this.sortedTypes.OwnerByAlphabet },
        { label: 'Док',         prop: 'tmPersonId', sortedType: this.sortedTypes.TmPersonId, hide: !this.userAccess.scPersTM },
        { label: 'Корпорация',  prop: 'corpId', sortedType: this.sortedTypes.CorpName },
        { label: 'Парковка',    prop: 'parkName', sortedType: this.sortedTypes.ParkName },
        { label: 'Нач.',        prop: 'dateBeg', sortedType: this.sortedTypes.DateBeg },
        { label: 'Кон.',        prop: 'dateEnd', sortedType: this.sortedTypes.DateEnd },
        { label: 'Заезд',       prop: 'dateIn', sortedType: this.sortedTypes.DateIn },
        { label: 'Выезд',       prop: 'dateOut', sortedType: this.sortedTypes.DateOut },
        { label: 'Время',       prop: 'timePark', sortedType: this.sortedTypes.TimeOnParking },
        { label: 'Сумма',       prop: 'balance', sortedType: this.sortedTypes.Balance },
        // { label: 'Дней', prop: 'dayInMonth', sortedType: this.sortedTypes.DaysOnParking },
        { label: 'Комментарий', prop: 'tarifName', sortedType: this.sortedTypes.TarifName },
      ];
    }

    get loading() { return this.$store.state.carList.loading; }
    get userAccess(): IAuth.UserAccess { return this.$store.state.auth.userAccess; }

    printCellValue(row: ICar.IEntity, prop: string) {
      let valueByProp = {
        'carNumber': row.carNumber,
        'persName': `${row.persName ? row.persName : ''}${row.guestFlag ? ' (гость)' : ''}`,
        'tmPersonId': row.tmPersonId,
        'corpId': row.corpName,
        'parkName': row.parkName,
        'dateBeg': this.printDate(row.dateBeg, false, false),
        'dateEnd': this.printDate(row.dateEnd, false, false),
        'dateIn': this.printDate(row.dateIn, true, false),
        'dateOut': this.printDate(row.dateOut, true, false),
        'timePark': row.timePark,
        'balance': this.$options.filters.currency(row.balance, '₽'),
        // 'dayInMonth': row.dayInMonth,
        'tarifName': row.tarifName,
      };
      return valueByProp[prop];
    }

    mounted() {
      const carStatusesMap = this.$store.state.book.books.carStatuses;

      carStatusesMap.forEach((item) => {
        Vue.set(this.carStatusesMap, item.id, item);
      });

      const sortedByStorage = localStorage.getItem(ICarList.LocalStorageKeys.SortedBy) as ICarList.SortedType;
      const directionStorage = localStorage.getItem(ICarList.LocalStorageKeys.SortedDirection);

      this.sortedType = sortedByStorage ? sortedByStorage : ICarList.SortedType.OwnerByAlphabet;
      this.sortDirectionUp = directionStorage ? JSON.parse(directionStorage) : true;

      this.$store.commit('carList/setProperty', { name: 'activeSortedType', value: this.sortedType });
      this.$store.commit('carList/setProperty', { name: 'sortDirectionUp', value: this.sortDirectionUp });
    }

    printDate(date: string, withTime: boolean = true, withYear: boolean = true) {
      return date ? this.$options.filters.moment(date, `DD.MM${withYear ? '.YYYY' : ''} ${withTime ? 'HH:mm' : ''}`) : '';
    }

    async openCarPopup(id: number) {
      await this.$store.dispatch('car/openCarPopup', { carId: id });
    }

    sortBy(sortedType) {
      if (sortedType === this.sortedType) {
        this.sortDirectionUp = !this.sortDirectionUp;
      }
      else {
        this.sortDirectionUp = true;
        this.sortedType = sortedType;
      }

      this.$store.commit('carList/setProperty', { name: 'activeSortedType', value: this.sortedType });
      this.$store.commit('carList/setProperty', { name: 'sortDirectionUp', value: this.sortDirectionUp });

      localStorage.setItem(ICarList.LocalStorageKeys.SortedBy, sortedType);
      localStorage.setItem(ICarList.LocalStorageKeys.SortedDirection, String(this.sortDirectionUp));
    }
  }
